// extracted by mini-css-extract-plugin
module.exports = {"nav":"StickyNav_nav__hNKhA","inner":"StickyNav_inner__kiT3_","tab":"StickyNav_tab__lqTBH","active":"StickyNav_active__L_MCV"};